@if (isEntainUi) {
    <bs-betbuilder-pick-ui
        [isCombo]="isCombo"
        [isEpcotEnabled]="isEpcotEnabled"
        [headerTitle]="headerText"
        [pick]="pick"
        [date]="date"
        [selections]="selections"
        [isRemoveButtonVisible]="shouldShowRemoveButton"
        (removeSelection)="removeBetBuilderSelection($event)">
    </bs-betbuilder-pick-ui>
} @else {
    <div class="pick-content">
        <div class="names-box">
            <div class="names-wrapper">
                <div [ngClass]="getClass('option-row__epcot_combo_header', 'option-row__header')">
                    <div [ngClass]="getClass('option-row__epcot_combo_header-line-0', 'bet-builder-icon')">
                        {{ headerText }}
                    </div>
                    <div [ngClass]="isEpcotEnabled ? 'betslip-digital-pick__line-1' : 'option'" [msAutomation]="'betslip-pick-option-name'">
                        {{ pick.event.event.name.name }}
                        @if (shouldShowMinSelectionError) {
                            <bs-betslip-betbuilder-selection-error />
                        }
                    </div>
                </div>

                <div class="betslip-digital-pick__line-0">
                    @for (leg of pick.getLegs(); track leg) {
                        <div class="bet-builder-market-leg">
                            <div class="bet-builder-circle-overlay">
                                <div class="bet-builder-circle theme-radio-off"></div>
                            </div>
                            <span class="bet-builder-leg">{{ leg }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
